export function isObject(obj: any): obj is typeof obj & {} {
  return typeof obj === 'object' && obj !== null && !Array.isArray(obj)
}

export async function delay(duration: number) {
  return new Promise(r => setTimeout(r, duration))
}

export function objectHasKey<T extends object>(obj: T, key: string): key is typeof key & keyof T {
  return key in obj
}

export function withoutKeys<O extends object, K extends keyof O>(obj: O, keys: K[]): Omit<O, K> {
  if (!isObject(obj)) {
    return obj
  }

  const shallowCopy = { ...obj }

  for (const key of keys) {
    delete shallowCopy[key]
  }

  return shallowCopy
}

export function withOnlyKeys<O extends object, K extends keyof O>(obj: O, keys: K[]): Pick<O, K> {
  const copied = <Pick<O, K>>{ }

  for (const key of keys) {
    copied[key] = obj[key]
  }

  return copied
}